import React, { useEffect, useState } from "react";
import { UiPopup } from "./UiModal";
import { SomethingWrongModal } from "../Popups/SomethingWrongModal";
import { ConfirmationIcon } from "../../../styles/img/svg/ConfirmationIcon";
import { UiButton } from "./UiButton";
import { useNavigate } from "react-router-dom";
import { responseCodes } from "../../../_redux/_constants/common.constants";
import { useTranslation } from "react-i18next";

const UiCustomErrors = (props) => {
  const [customTitle, setCustomTitle] = useState(null);
  const [customMessage, setCustomMessage] = useState(null);
  const [hideServiceSideMessage, setHideServiceSideMessage] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleCloseModal = () => {
    setCustomMessage(null);
    setCustomTitle(null);
  };

  const goToForgot = () => {
    setCustomMessage(null);
    setCustomTitle(null);
    navigate("/forgot-username");
  };

  useEffect(() => {
    if (props?.customError?.statusCode) {
      switch (props?.customError?.statusCode) {
        case responseCodes.AUTH_ERROR_PASSWORD_INCORRECT:
          setCustomTitle(t("Login Incorrect!"));
          setCustomMessage(
            t(
              "It seems like the username or password you provided are incorrect. Please double-check your credentials and try again",
            ),
          );
          break;

        case responseCodes.AUTH_ERROR_USERNAME_PASSWORD_INCORRECT:
          setCustomTitle(t("Login Incorrect!"));
          setCustomMessage(
            t(
              "It seems like the username or password you provided are incorrect. Please double-check your credentials and try again",
            ),
          );
          setHideServiceSideMessage(true);
          break;

        default:
          break;
      }
    }
  }, [props?.customError]);

  useEffect(() => {
    if (customTitle && customMessage) {
      setOpenModal(true);
    } else {
      setOpenModal(false);
    }
  }, [customMessage, customTitle]);

  return (
    <>
      {openModal ? (
        <UiPopup openModal={openModal} handleClose={handleCloseModal}>
          <SomethingWrongModal
            icon={<ConfirmationIcon />}
            message={t(customTitle)}
            buttonText={t("Ok")}
            buttonOnClick={handleCloseModal}
            className="df-confirmation-message-popup"
            buttonClass="df-ui-dark-bg-btn df-w-90-btn"
          >
            <p>
              {t(customMessage)}
              <br />
              <span className="df-modal-timer mb-1">
                {!hideServiceSideMessage && props.customError?.message}
              </span>
            </p>

            {/* <UiButton
              name={t("Forgot login details?")}
              className="df-primary-underlined-btn mb-0"
              onClick={goToForgot}
            /> */}
          </SomethingWrongModal>
        </UiPopup>
      ) : null}
    </>
  );
};

export default UiCustomErrors;
